export const SET_WHD_SCROLL_POSITION = 'SET_WHD_SCROLL_POSITION';

function storeStatementPosition(accountId, scrollPosition) {
  return {
    type: SET_WHD_SCROLL_POSITION,
    accountId,
    scrollPosition
  };
}

export function setStatementPosition(accountId, scrollPosition) {
  return dispatch => dispatch(storeStatementPosition(accountId, scrollPosition));
}
